import { createRouter, createWebHistory } from 'vue-router'
import LandingView from '../views/LandingView.vue'
import RoomView from '../views/RoomView.vue'
import LoginView from '../views/LoginView.vue'
import CallbackView from '@/views/CallbackView.vue'
import NotFoundView from '@/views/NotFoundView.vue'
import CallbackLinearView from '@/views/CallbackLinearView.vue'
import ProfileView from '@/views/ProfileView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: LandingView,
    },
    {
      path: '/room/:id',
      name: 'room',
      component: RoomView,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      path: '/callback',
      name: 'callback',
      component: CallbackView
    },
    {
      path: '/profile',
      name: 'profile',
      component: ProfileView
    },
    {
      path: '/callback-linear',
      name: 'callback-linear',
      component: CallbackView,
      beforeEnter: async (route) => {
        return  {
          name: 'linear-auth',
          query: {
            code: route.query.code,
            state: route.query.state
          }
        }
      }
    },
    {
      path: '/linear-auth',
      name: 'linear-auth',
      component: CallbackLinearView,
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: NotFoundView
    }
  ]
})

export default router
